import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '@core/services/local-storage.service';

@Component({
  selector: 'app-change-offer-success',
  templateUrl: './change-offer-success.component.html',
  styleUrls: ['./change-offer-success.component.css']
})
export class ChangeOfferSuccessComponent {
  type: string | null = null;

  constructor(private route: ActivatedRoute, 
    private router: Router, 
    private localStorageService: LocalStorageService) {
    this.route.queryParamMap.subscribe(params => {
      this.type = params.get('type');
    });
  }

  goToNotreCompte() {
    if (this.type) {
      this.localStorageService.saveData('redirectionType', this.type)
    }
    this.router.navigate(['/notre-compte'], {
      state: { redirectionType: this.type }
    });
  }
}
